import { EventEmitter, Injectable } from '@angular/core'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { AuthService } from '@spartacus/core'
import { Observable, ReplaySubject, combineLatest, of } from 'rxjs'
import { mergeMap, share, switchMap, take } from 'rxjs/operators'
import bufferDebounceTime from '../../../../util/buffer-debounce-time'
import { EbAvailability, EbAvailabilityItem } from '../../interfaces/eb-availability.interface'
import { EbAvailabilityAdapter } from '../connectors/eb-availability.adapter'

@Injectable()
export class EbAvailabilityService {
  validatingShippingDateEvent = new EventEmitter<boolean>(false)

  constructor(
    private readonly availabilityAdapter: EbAvailabilityAdapter,
    private readonly authService: AuthService,
    protected activeCartService: ActiveCartFacade
  ) {}

  requestAvailabilitySubject = new ReplaySubject<{
    availability: EbAvailabilityItem
  }>(1)
  singleAvailabilityFetcher$ = this.requestAvailabilitySubject.pipe(
    bufferDebounceTime(500),
    mergeMap(items => {
      const availabilityItems: EbAvailabilityItem[] = items.map(item => item.availability)
      return this.availabilityAdapter.fetchAvailabilities(availabilityItems)
    }),
    share()
  )

  fetchAvailability(availability: EbAvailabilityItem): Observable<EbAvailability> {
    return combineLatest([
      this.authService.isUserLoggedIn()
    ]).pipe(
      take(1),
      switchMap(([isLoggedIn]) => {
        if (isLoggedIn) {
          this.requestAvailabilitySubject.next({ availability })
          return this.singleAvailabilityFetcher$
        } else {
          return of({} as EbAvailability)
        }
      })
    )
  }

  fetchAvailabilities(
    availabilities: EbAvailabilityItem[],
    invalidateCache = false,
    shippingDate = ''
  ): Observable<EbAvailability> {
    return combineLatest([
      this.authService.isUserLoggedIn()
    ]).pipe(
      take(1),
      switchMap(([isLoggedIn]) => {
        if (isLoggedIn) {
          return this.availabilityAdapter.fetchAvailabilities(
            availabilities,
            invalidateCache,
            shippingDate
          )
        } else {
          return of({} as EbAvailability)
        }
      })
    )
  }

  setEarliestShippingDate(availabilities: EbAvailabilityItem[]) {
    return this.availabilityAdapter.setEarliestShippingDate(availabilities)
  }

  emitValidatingShippingDateEvent(validating: boolean) {
    this.validatingShippingDateEvent.emit(validating)
  }
}
